// extracted by mini-css-extract-plugin
export default {"DigestMonthDays":"digest-month-days_DigestMonthDays__J9-Gq","DigestRow":"digest-month-days_DigestRow__sURPn","DaysBlock":"digest-month-days_DaysBlock__Wqoy4"};